<template>
<el-card>
     <el-collapse accordion>
         <el-collapse-item title="LMS Progress" name="2">
   <p>Tutor: {{tutor.firstname}} {{tutor.lastname}}</p>
        <div v-for="course in progress" v-show="!loadingProgress">
         <el-popover
    placement="top-start"
    
    width="400"
    trigger="hover"
  >
  <h3>{{course.courseName}}</h3>
  <ul style="list-style-type: none;padding:5px;background-color:#f5f5f5">
  <li v-for="lesson in course.lessons">
   {{lesson.name}} {{lesson.currentPoints}}/{{lesson.maximumPoints}}
   <el-progress :percentage="Number(lesson.currentPoints/lesson.maximumPoints*100).toFixed(0)"></el-progress>

  </li>
  </ul>
   <el-progress
   slot="reference"
            :stroke-width="20"
            :loading="loadingProgress"
            :text-inside="true"
            :percentage="Number(course.enrollmentCurrentPoints/course.courseMaximumPoints).toFixed(2)*100"
          ></el-progress>
  </el-popover>
          
          {{course.courseName}} - {{course.enrollmentStatus}}
        </div>
        <el-button  size="mini" @click="getLMSProgress(customer.email)">
          <i class="fa fa-bar-chart-o"></i>
        </el-button>
               </el-collapse-item>
        </el-collapse>
</el-card>
</template>
<script>
import LMSapi from "../../../api/lmsAPI";

export default {
  props: ["customer"],
  data() {
    return {
      loadingProgress: false,
        progress: [],
        tutor:''
    };
  },
  components: {},
  methods: {
    getLMSProgress(email) {
      this.loadingProgress = true;
      const progress = LMSapi.getProgress(email);
      const tutor =  LMSapi.getTutor(email);
      Promise.all([progress,tutor])
        .then(([result,res]) => {
          this.progress = result.data.data;
          this.loadingProgress = false;
          this.tutor=res.data.data
        })
        .catch(e => {
          this.$notify({
            title: "Error",
            message: "Can't connect to the LMS right now",
            type: "error"
          });
        });
         
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/LMSProgress.vue